// Formatação numérica pt-PT para TODOS os widgets do dashboard: ponto a separar milhares,
// vírgula a separar decimais. Implementação manual (não usa toLocaleString) para ser determinística
// e idêntica no browser e nos testes — o ICU do ambiente de testes formata milhares de forma diferente.
// Sempre que um widget mostrar um valor monetário, usar formatEuros (nunca toFixed/toLocaleString ad hoc).

const groupThousands = (integerDigits: string) => {
    const grouped = integerDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return grouped;
};

const formatFixed = (value: number, fractionDigits: number) => {
    const safeValue = Number.isFinite(value) ? value : 0;
    const fixed = Math.abs(safeValue).toFixed(fractionDigits);
    const [integerPart, decimals] = fixed.split(".");
    const isNegative = safeValue < 0 && Number(fixed) !== 0;
    const sign = isNegative ? "-" : "";
    const grouped = groupThousands(integerPart);
    const formatted = decimals ? `${sign}${grouped},${decimals}` : `${sign}${grouped}`;
    return formatted;
};

export const formatEuros = (value: number) => {
    const formatted = `${formatFixed(value, 2)} €`;
    return formatted;
};

export const formatQuantity = (value: number) => {
    const formatted = formatFixed(Math.round(Number.isFinite(value) ? value : 0), 0);
    return formatted;
};

export const formatPercent = (value: number, fractionDigits = 2) => {
    const formatted = `${formatFixed(value, fractionDigits)}%`;
    return formatted;
};

export const formatDecimal = (value: number, fractionDigits = 2) => {
    const formatted = formatFixed(value, fractionDigits);
    return formatted;
};
